import * as React from "react"
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../scss/grunticon.scss";
import "../scss/bootstrap-overrides.scss";
import "../scss/global.scss";
import "../scss/custom.scss";
import { Header } from "../components/Header/Header";
import { Footer } from "../components/Footer/Footer";
import '../components/Static/AboutPage/About.scss';
import { Col, Container, Row } from "react-bootstrap";
import algoliasearch from 'algoliasearch/lite';
import SearchBanner from "../components/SearchResult/SearchBanner/Banner";
import FilterPage from "../components/SearchResult/FilterPage/Filter";
import PropertyCard from "../components/SearchResult/PropertyCard/PropertyCard";
import { RefinementList, InstantSearch, Configure, connectInfiniteHits, connectStateResults } from 'react-instantsearch-dom';
import MapDesktop from "../components/SearchResult/Map/MapDesktop";
import NoResultPage from "../components/SearchResult/NoResultPage";
import Loader from "../components/loader";
import { isAreaMatch, isEmpty, getLatLan, milesToMeter, removeSpecialChar } from "../utils";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_API_KEY);
const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

const CustomInfiniteHits = connectInfiniteHits(PropertyCard);

const LoadingIndicator = connectStateResults(
    ({ isSearchStalled }, props) =>
      isSearchStalled ? <div className="col-12"><Loader/></div> : <NoResultPage {...props}/>
);

const SearchTemplate = (props) => {
    const [sold, setIncludeSold] = React.useState(false);
    const [underOffer, setIncludeUnderOffer] = React.useState(false);
    const [bannerVal, SetBannerVal] = React.useState("");
    const [searchVal, SetSearchVal] = React.useState("");
    const [radius, SetRadius] = React.useState(3);
    const setMapUrl = (map) => {
        if(map) {
            props.changeToMapUrl()
        } else {
            props.changeToListUrl()
        }
    }


    React.useEffect(() => {
        if(isEmpty(searchVal) && !isEmpty(props.query)){
            SetSearchVal(props.query)
        } 
        if(radius === 3 && props.radius !== 3){  
            SetRadius(props.radius)
        }
    },[props.query, props.radius])
    const includeSold = (value) => {
        setIncludeSold(value)
    }

    const includeUnderOffer = (value) => {
        setIncludeUnderOffer(value)
    }

    const getRefinement = () => {
        if(props.searchType == "sales") {
            let sales = ["For Sale", "New Instruction"];
            if(sold && underOffer) {
                sales = ["For Sale", "New Instruction", "Sold", "Under Offer"];
            } else if(sold && !underOffer) {
                sales = ["For Sale", "New Instruction", "Sold"];
            } else if(!sold && underOffer) {
                sales = ["For Sale", "New Instruction", "Under Offer"];
            }
            return sales;
        } else {
            let rent = ["To Let", "New Instruction"];
            if(sold && underOffer) {
                rent = ["To Let", "New Instruction", "Let", "Under Offer"];
            } else if(sold && !underOffer) {
                rent = ["To Let", "New Instruction", "Let"];
            } else if(!sold && underOffer) {
                rent = ["To Let", "New Instruction", "Under Offer"];
            }
            return rent;
        }
    }
    let statusdata = getRefinement()

    let mystatus = ''
  if(statusdata){
    if(Array.isArray(statusdata)){
      mystatus = '(status:"'+(statusdata).join('" OR status:"')+'")'
    } else {
      mystatus = '(status:"'+(statusdata)+'")'
    }
  } 
 
  let aroundLatLng = null; 
  let aroundRadius = null;  
  let radiusAvailable = false;
  let matchArea = null;
  if (!isEmpty(props.areaList) && !isEmpty(searchVal)) {
      let sArea = isAreaMatch(props.areaList, searchVal);
      if (!isEmpty(sArea)) {
          radiusAvailable = true;
          aroundLatLng = getLatLan(sArea);
          aroundRadius = milesToMeter(radius) 
          matchArea = sArea.slug;
      }
  } 
    return (
        <div className="wrapper wrapper-static property-details-static">
            <Header/>
            <InstantSearch
                indexName={index_name}
                searchClient={client}
                onSearchStateChange={(state) => props.changeStateAndUrl(state, {area: matchArea, radiusAvailable, radius})}
                hits
                showLoadingIndicator 
            >
                 {radiusAvailable ?
                <Configure 
                        aroundLatLng={aroundLatLng}
                        aroundRadius={aroundRadius} 
                        filters={`searchType:${props.searchType} AND ${mystatus}`}
                        query="" 
                        />
                    :
                    <Configure filters={`searchType:${props.searchType} AND ${mystatus}`} query={removeSpecialChar(searchVal)} />
                }
                <SearchBanner searchType={props.searchType} query={props.query} bannerVal = {bannerVal}/>
                <section className="search-results">
                    <Container>
                            <Row>
                                <Col className="col-12 p-0">
                                    <FilterPage
                                        {...props}
                                        setMapview={setMapUrl}
                                        includeSold={includeSold}
                                        includeUnderOffer={includeUnderOffer}
                                        mapView={props.mapView}
                                        index_name={index_name}
                                        sales={props.searchType == "sales" ? true : false }
                                        setbanner = {SetBannerVal}
                                        setSearchVal={SetSearchVal}
                                        setRadius={SetRadius}
                                        searchVal={searchVal}
                                        radius={radius}
                                        radiusAvailable={radiusAvailable}
                                    />
                                </Col> 
                               
                                <div className="d-none">
                                    {/* <RefinementList
                                        attribute="searchType"
                                        defaultRefinement={[props.searchType]}
                                    />
                                    <RefinementList
                                        attribute="status"
                                        defaultRefinement={getRefinement()}
                                    /> */}
                                    {/* <RefinementList
                                        attribute="publish"
                                        defaultRefinement={["true"]}
                                    /> */}
                                </div>            
                                {!props.mapView &&
                                    <Col className="col-12 p-0">
                                        <CustomInfiniteHits {...props}/>
                                    </Col> 
                                }
                            </Row>
                        </Container>
                    </section>
                    {props.mapView && 
                        <div className="geo-map m-auto w-100">
                            <Configure hitsPerPage={1000}/>
                            <MapDesktop {...props}/>
                        </div>
                    }
                    {!props.mapView && <LoadingIndicator/>}
                </InstantSearch>
            <Footer search={props.searchType == "sales" ? "Popular_Search_Sales" : "Popular_Search_Rent"}/>
        </div>
    )
}

export default SearchTemplate;
